import * as pay from "./pay";

export const nice = {
    ...pay,
}
